import React from "react";
import "./testimonials.css";
import AVTR1 from "../../assets/avatar1.jpg";
import AVTR2 from "../../assets/avatar2.jpg";
import AVTR3 from "../../assets/avatar3.jpg";
import AVTR4 from "../../assets/avatar4.jpg";

// import Swiper core and required modules
import { Pagination } from "swiper";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

const data = [
  {
    avatar: AVTR1,
    name: "Paolo Solis",
    review:
      "José demostró un alto nivel de compromiso y creatividad en nuestro proyecto. Su capacidad para resolver problemas y aportar ideas innovadoras fue clave para el éxito del equipo. Sin duda, volvería a trabajar con él.",
  },
  {
    avatar: AVTR2,
    name: "Juan Puerto",
    review:
      "Trabajar con José fue una experiencia muy positiva. Su atención al detalle y su capacidad para cumplir con los plazos hicieron que el proyecto avanzara sin contratiempos. Recomiendo su trabajo a cualquier empresa que busque resultados de calidad.",
  },
  {
    avatar: AVTR3,
    name: "Joaquin Tiesi",
    review:
      "José es un profesional dedicado y resolutivo. Su capacidad para adaptarse a nuevos retos y su enfoque en la calidad del código fueron fundamentales para el éxito de nuestro proyecto. Recomiendo su trabajo sin dudarlo.",
  },
];

const Testimonials = () => {
  return (
    <section id="testimonials">
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper
        className="container testimonials__container"
        // install Swiper modules
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        {data.map(({ avatar, name, review }, index) => {
          return (
            <SwiperSlide key={index} className="testimonial">
              <div className="client__avatar">
                <img src={avatar} />
              </div>
              <h5 className="client__name">{name}</h5>
              <small className="client__review">{review}</small>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default Testimonials;
